export const languages = [
    {
        name: "French",
        language: "fr-FR"
    }, {
        name: "American English",
        language: "en-US"
    },
    {
        name: "British English",
        language: "en-GB"
    },
    {
        name: "Spanish",
        language: "es-ES"
    },
    {
        name: "Brazilian Portuguese",
        language: "pt-BR"
    },
    {
        name: "Japanese",
        language: "ja-JP"
    },
    {
        name: "Mandarin",
        language: "zh-CN"
    },
    {
        name: "Cantonese",
        language: "zh-CN-yue"
    },
    {
        name: "Vietnamese",
        language: "vi-VN"
    },
    {
        name: "Korean",
        language: "ko-KR"
    },
    {
        name: "Standard Arabic",
        language: "ar-AR"
    },
    {
        name: "German",
        language: "de-DE"
    },
    {
        name: "Hindi",
        language: "hi-IN"
    }
];

export const roles = {
    ADMIN: 'admin',
    USER: 'user',
    TRANSLATOR: 'translator'
}
